/**
 * Назначение вложения оборудования — зеркало App\Enums\InventoryFileCategory.
 *
 * Не тип файла и не папка: категория отвечает на вопрос «зачем снят этот кадр»,
 * а тип виден из mime. Список закрытый с обеих сторон — бэкенд отклоняет чужое значение
 * с 422, поэтому добавлять сюда пункт в одностороннем порядке нельзя.
 */
export default class InventoryFileCategory {
    /**
     * Значение по умолчанию, когда категорию не выбрали. Именно «общее», а не «прочее»:
     * это самый частый случай, а не остаток.
     */
    static GENERAL = 'general';

    static WAREHOUSE_RECEIVE = 'warehouse_receive';
    static ISSUE_TO_EMPLOYEE = 'issue_to_employee';
    static RETURN_TO_WAREHOUSE = 'return_to_warehouse';
    static REPAIR_SEND = 'repair_send';
    static REPAIR_RETURN = 'repair_return';
    static WRITEOFF = 'writeoff';

    /**
     * Осознанный выбор человека, а не значение по умолчанию — им служит GENERAL.
     */
    static OTHER = 'other';
}
